import AbstractPickerButton from './at_abstract_picker_button'
import WeekPickerMenu from './at_week_picker_menu'
import Ext from 'Ext'

const WeekSelector = Ext.extend(AbstractPickerButton,
{
    createMenu: function()
    {
        return new WeekPickerMenu(
                {
                    minDate: this.minValue,
                    maxDate: this.maxValue,
                    format: this.format,
                    scheduleCalculator: this.scheduleCalculator,
                    startDay: this.weekStartDay,
                    value: this.date ? this.date : new Date().clearTime(),
                    minText:  this.minText,
                    maxText: this.maxText
                } );
    }

});

export default WeekSelector



// WEBPACK FOOTER //
// ./web/js/controls/dateControls/WeekSelector.js